import { createAction, props } from '@ngrx/store';

import { Locations } from 'app/shared/features/location-selector/models';

export const updateLocations = createAction(
    '[Location Selection] Update Locations',
    props<{ locations: Locations[] }>(),
);
